// import React, { useEffect, useState } from "react";
// import { Edit, Trash2, ArrowLeftRight } from "lucide-react";
// import axios from "axios";
// import { useNavigate, useParams } from "react-router-dom";
// import Apiurl from "../../environment/Apiurl";

// const UpdateSalePharmacy = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [showAddModal, setShowAddModal] = useState(false);
//   const [responseData, setResponseData] = useState([]);
//   const [responsePatientData, setResponsePatientData] = useState([]);
//   const [selectedMedicines, setSelectedMedicines] = useState([]);
//   const [medicineSearch, setMedicineSearch] = useState("");
//   const [patientSearch, setPatientSearch] = useState("");
//   const [showMedicineDropdown, setShowMedicineDropdown] = useState(false);
//   const [showPatientDropdown, setShowPatientDropdown] = useState(false);
//   const [isLoadingPatients, setIsLoadingPatients] = useState(false);
//   const [formData, setFormData] = useState({
//     sale_date: new Date().toISOString().split("T")[0],
//     invoice_number: "",
//     patient_id: "",
//     patient_name: "",
//     mobile: "",
//     discount_percentage: 0,
//     discount_value: 0,
//     apply_gst: true,
//     gst_amount: 0,
//     sub_total: 0,
//     net_total: 0,
//     round_off: 0,
//     paid: 0,
//     balance: 0,
//     notes: "",
//     payment_type: "",
//   });
//   const [paymentData, setPaymentData] = useState({
//     paid_date: new Date().toISOString().split("T")[0],
//     pay_type: "",
//     paid_amount: "",
//   });
//   const [paymentTableData, setPaymentTableData] = useState([]);
//   const [selectedMedicine, setSelectedMedicine] = useState({
//     stock_id: "",
//     medicine_id: "",
//     medicine_name: "",
//     hsn_code: "",
//     batch_no: "",
//     balance_quantity: 0,
//     quantity: 0,
//     mrp: 0,
//     gst_percentage: 0,
//     cgst: 0,
//     sgst: 0,
//     expiry_date: "",
//     unit: "",
//     unit_pack: "",
//     quantity_multiplier: 1,
//     originalIndex: null,
//     total: 0,
//   });
//   const [selected_medicine, setselected_medicine] = useState({});
//   const [isLoading, setIsLoading] = useState(true);

//   // Fetch medicines from API
//   const fetchResponse = async () => {
//     try {
//       const response = await axios.get(`${Apiurl}/stock_pharmacy`);
//       setResponseData(response.data || []);
//     } catch (error) {
//       console.error("Error fetching medicines:", error.message);
//     }
//   };

//   // Fetch patients from API
//   const fetchResponsePatient = async () => {
//     setIsLoadingPatients(true);
//     try {
//       const response = await axios.get(`${Apiurl}/patient_details`);
//       setResponsePatientData(response.data || []);
//     } catch (error) {
//       console.error("Error fetching patients:", error.message);
//     } finally {
//       setIsLoadingPatients(false);
//     }
//   };

//   // Fetch existing sale data
//   const fetchSaleData = async () => {
//     try {
//       const response = await axios.get(`${Apiurl}/sale_pharmacy/${id}`);
//       const sale = response.data;
//       setFormData({
//         sale_date: sale.sale_date.split("T")[0],
//         invoice_number: sale.invoice_number || "",
//         patient_id: sale.patient_id || "",
//         patient_name: sale.patient_details[0]?.first_name || "",
//         mobile: sale.patient_details[0]?.mobile_no || "",
//         discount_percentage: parseFloat(sale.discount_percentage) || 0,
//         discount_value: parseFloat(sale.discount_value) || 0,
//         apply_gst: sale.apply_gst !== undefined ? sale.apply_gst : true,
//         gst_amount: parseFloat(sale.gst_amount) || 0,
//         sub_total: parseFloat(sale.sub_total) || 0,
//         net_total: parseFloat(sale.net_total) || 0,
//         round_off: parseFloat(sale.round_off) || 0,
//         paid: parseFloat(sale.paid) || 0,
//         balance: parseFloat(sale.balance) || 0,
//         notes: sale.notes || "",
//         payment_type: sale.payment_type || "",
//       });
//       setPatientSearch(
//         `${sale.patient_id} - ${sale.patient_details[0]?.first_name || ""}`
//       );
//       const medicines = sale.sales_list.map((item) => ({
//         stock_id: item.stock_id || "",
//         medicine_id: item.medicine_id || "",
//         medicine_name:
//           item.medicine_details?.medicine_name || item.medicine_name || "",
//         hsn_code: item.hsn_code || "",
//         batch_no: item.batch_no || "",
//         balance_quantity: parseInt(item.balance_quantity) || 0,
//         quantity: parseInt(item.quantity) || 0,
//         mrp: parseFloat(item.mrp) || 0,
//         gst_percentage: parseFloat(item.gst_percentage) || 0,
//         cgst: parseFloat(item.cgst) || 0,
//         sgst: parseFloat(item.sgst) || 0,
//         expiry_date: item.expiry_date || "",
//         unit: item.unit || "",
//         unit_pack: item.unit_pack || "1*1",
//         total: parseFloat(item.total) || 0,
//         quantity_multiplier: parseFloat(item.quantity_multiplier) || 1,
//       }));
//       setSelectedMedicines(medicines);
//       const payments = sale.sales_pharmacy_payment.map((payment) => ({
//         id: payment._id || "",
//         paid_date: payment.paid_date.split("T")[0] || "",
//         pay_type: payment.pay_type || "",
//         paid_amount: parseFloat(payment.paid_amount) || 0,
//       }));
//       setPaymentTableData(payments);
//       setIsLoading(false);
//     } catch (error) {
//       console.error("Error fetching sale data:", error);
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchResponse();
//     fetchResponsePatient();
//     fetchSaleData();
//   }, [id]);

//   // Recalculate totals whenever selectedMedicines or paymentTableData changes
//   useEffect(() => {
//     setFormData((prev) => recalculateFormTotals(prev));
//   }, [selectedMedicines, paymentTableData]);

//   // Recalculate form totals
//   const recalculateFormTotals = (formState) => {
//     const subTotal = selectedMedicines.reduce((sum, item) => {
//       const mrp = parseFloat(item.mrp) || 0;
//       const quantity = parseInt(item.quantity) || 0;
//       const cgst = parseFloat(item.cgst) || 0;
//       const sgst = parseFloat(item.sgst) || 0;
//       return sum + quantity * mrp - (cgst + sgst);
//     }, 0);
//     const discountPercentage = parseFloat(formState.discount_percentage) || 0;
//     const discountValue = (subTotal * discountPercentage) / 100;
//     const gstAmount = formState.apply_gst
//       ? selectedMedicines.reduce((sum, item) => {
//           const cgst = parseFloat(item.cgst) || 0;
//           const sgst = parseFloat(item.sgst) || 0;
//           return sum + (cgst + sgst);
//         }, 0)
//       : 0;
//     const netTotal = subTotal - discountValue + gstAmount;
//     const netTotalDecimal = netTotal % 1;
//     let roundOff = 0;
//     let roundedNetTotal = netTotal;
//     if (netTotalDecimal >= 0.5) {
//       roundedNetTotal = Math.ceil(netTotal);
//       roundOff = roundedNetTotal - netTotal;
//     } else {
//       roundedNetTotal = Math.floor(netTotal);
//       roundOff = roundedNetTotal - netTotal;
//     }
//     const paid = paymentTableData.reduce(
//       (sum, item) => sum + (parseFloat(item.paid_amount) || 0),
//       0
//     );
//     const balance = roundedNetTotal - paid;
//     return {
//       ...formState,
//       sub_total: subTotal || 0,
//       discount_value: discountValue || 0,
//       gst_amount: gstAmount || 0,
//       net_total: roundedNetTotal || 0,
//       round_off: roundOff || 0,
//       paid: paid || 0,
//       balance: balance || 0,
//     };
//   };

//   // Handle form input changes
//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prev) => {
//       const newData = {
//         ...prev,
//         [name]: type === "checkbox" ? checked : value,
//         [name]:
//           name === "discount_percentage"
//             ? Math.max(parseFloat(value) || 0, 0)
//             : value,
//       };
//       if (name === "discount_percentage" || name === "apply_gst") {
//         return recalculateFormTotals(newData);
//       }
//       return newData;
//     });
//   };

//   // Handle patient search and dropdown
//   const handlePatientFocus = () => setShowPatientDropdown(true);
//   const handlePatientBlur = () => {
//     setTimeout(() => setShowPatientDropdown(false), 200);
//   };
//   const filteredPatients = responsePatientData.filter((patient) =>
//     `${patient.patient_id} ${patient.first_name}`
//       .toLowerCase()
//       .includes(patientSearch.toLowerCase())
//   );
//   const selectPatient = (patient) => {
//     setFormData((prev) => ({
//       ...prev,
//       patient_id: patient.patient_id || "",
//       patient_name: patient.first_name || "",
//       mobile: patient.mobile_no || "",
//     }));
//     setPatientSearch(`${patient.patient_id} - ${patient.first_name}`);
//     setShowPatientDropdown(false);
//   };

//   // Handle medicine search and dropdown
//   const handleMedicineFocus = () => setShowMedicineDropdown(true);
//   const handleMedicineBlur = () => {
//     setTimeout(() => setShowMedicineDropdown(false), 200);
//   };
//   const filteredMedicines = responseData.filter((item) => {
//     const medicineName =
//       item.medicine_details?.medicine_name ||
//       item.medicine_details?.[0]?.medicine_name ||
//       "";
//     const batchNo = item.batch_no || "";
//     const hsnCode =
//       item.medicine_details?.hsn_code ||
//       item.medicine_details?.[0]?.hsn_code ||
//       "";
//     const balanceQuantity = item.balance_quantity || 0;
//     const searchText = `${medicineName} ${batchNo} ${hsnCode}`.toLowerCase();
//     return (
//       (searchText.includes(medicineSearch.toLowerCase()) &&
//         balanceQuantity > 0) ||
//       medicineName === "Consumables"
//     );
//   });
//   const selectMedicine = (medicine) => {
//     const medicineName =
//       medicine.medicine_details?.medicine_name ||
//       medicine.medicine_details?.[0]?.medicine_name ||
//       "Unknown";
//     const hsnCode =
//       medicine.medicine_details?.hsn_code ||
//       medicine.medicine_details?.[0]?.hsn_code ||
//       "";
//     const unitPack =
//       medicine.medicine_details?.unit_pack ||
//       medicine.medicine_details?.[0]?.unit_pack ||
//       "";

//     const isConsumables = medicineName === "Consumables";
//     let initialQuantity = isConsumables ? "" : 1;
//     let initialMrp = isConsumables ? "" : parseFloat(medicine.mrp) || 0;
//     let initialGst = parseFloat(medicine.gst_percentage || 0);
//     let initialCgst = 0;
//     let initialSgst = 0;
//     if (!isConsumables) {
//       const basePrice = initialMrp / (1 + initialGst / 100);
//       const taxAmountPerUnit = initialMrp - basePrice;
//       const taxAmount = initialQuantity * taxAmountPerUnit;
//       initialCgst = taxAmount / 2;
//       initialSgst = taxAmount / 2;
//     }

//     setselected_medicine(medicine);

//     setSelectedMedicine({
//       stock_id: medicine._id,
//       medicine_id: medicine.medicine_id,
//       batch_no: medicine.batch_no || "",
//       balance_quantity: medicine.balance_quantity || 0,
//       quantity: initialQuantity,
//       mrp: initialMrp,
//       gst_percentage: initialGst,
//       cgst: initialCgst,
//       sgst: initialSgst,
//       expiry_date: medicine.expiry_date || "",
//       unit_pack: medicine.unit_pack,
//       medicine_name: medicineName,
//       hsn_code: hsnCode,
//       unit: isConsumables ? "Other" : "",
//       quantity_multiplier: 1,
//       originalIndex: null,
//       total: isConsumables ? 0 : initialMrp,
//     });
//     setMedicineSearch(medicineName);
//     setShowMedicineDropdown(false);
//   };

//   // Handle medicine input changes
//   const handleMedicineInputChange = (e) => {
//     const { name, value } = e.target;
//     const isConsumables = selectedMedicine.medicine_name === "Consumables";
//     let mrp_rate = selected_medicine.mrp || 0;
//     let quantity_multiplier = 1;

//     if (
//       !isConsumables &&
//       name === "unit" &&
//       (value === "Tablet" || value === "Bottle" || value === "Per Piece") &&
//       selected_medicine.unit_pack?.includes("*")
//     ) {
//       const qty_per_unit = selected_medicine.unit_pack.split("*");
//       if (qty_per_unit[1] && !isNaN(parseFloat(qty_per_unit[1]))) {
//         mrp_rate =
//           parseFloat(selected_medicine.mrp) / parseFloat(qty_per_unit[1]);
//       }
//     } else if (
//       !isConsumables &&
//       name === "unit" &&
//       (value === "Strip" || value === "Pack") &&
//       selected_medicine.unit_pack?.includes("*")
//     ) {
//       const qty_per_unit = selected_medicine.unit_pack.split("*");
//       if (qty_per_unit[1] && !isNaN(parseFloat(qty_per_unit[1]))) {
//         quantity_multiplier = parseFloat(qty_per_unit[1]);
//       }
//     }

//     setSelectedMedicine((prev) => {
//       let updatedMedicine = { ...prev };

//       if (name === "quantity") {
//         updatedMedicine[name] = parseInt(value) || 0;
//       } else if (name === "mrp" && isConsumables) {
//         updatedMedicine[name] = parseFloat(value) || 0;
//       } else {
//         updatedMedicine[name] = value;
//       }

//       if (name === "unit" && !isConsumables) {
//         updatedMedicine.mrp = parseFloat(mrp_rate);
//         updatedMedicine.quantity_multiplier = quantity_multiplier;
//       }

//       // Recalculate tax-related fields
//       const currentMrp = parseFloat(updatedMedicine.mrp) || 0;
//       const currentGst = parseFloat(updatedMedicine.gst_percentage) || 0;
//       const currentQty = parseInt(updatedMedicine.quantity) || 0;
//       const base_price = currentMrp / (1 + currentGst / 100);
//       const tax_amount_per_unit = currentMrp - base_price;
//       const tax_amount = currentQty * tax_amount_per_unit;

//       const finalMedicine = {
//         ...updatedMedicine,
//         cgst: tax_amount / 2,
//         sgst: tax_amount / 2,
//         total: currentQty * currentMrp,
//       };
//       return finalMedicine;
//     });
//   };

//   // Edit medicine
//   const editMedicine = (medicine, index) => {
//     const stockData = responseData.find(
//       (item) =>
//         item.medicine_id === medicine.medicine_id &&
//         item.batch_no === medicine.batch_no
//     );
//     if (stockData) {
//       setselected_medicine(stockData);
//     }
//     setSelectedMedicine({
//       ...medicine,
//       balance_quantity:
//         responseData.find((m) => m._id === medicine.stock_id)
//           ?.balance_quantity || 0,
//       quantity_multiplier: parseFloat(medicine.quantity_multiplier) || 1,
//       originalIndex: index,
//     });
//     setMedicineSearch(medicine.medicine_name || "");
//   };

//   // Handle return click for medicine
//   const handleReturnClick = (item) => {
//     const returnQtyInput = prompt(
//       `Enter return quantity for ${item.medicine_name} (current sold: ${item.quantity})`
//     );
//     if (
//       !returnQtyInput ||
//       isNaN(returnQtyInput) ||
//       parseInt(returnQtyInput) <= 0
//     ) {
//       return;
//     }
//     const returnQty = parseInt(returnQtyInput);
//     if (returnQty > item.quantity) {
//       alert("Cannot return more than the sold quantity.");
//       return;
//     }
//     // Find the index in selectedMedicines
//     const index = selectedMedicines.findIndex(
//       (m) =>
//         m.medicine_id === item.medicine_id &&
//         m.batch_no === item.batch_no &&
//         m.unit === item.unit
//     );
//     if (index !== -1) {
//       const newQuantity = item.quantity - returnQty;
//       updateQuantity(index, newQuantity);
//       alert(
//         `Returned ${returnQty} units. New quantity: ${newQuantity}. Stock will be adjusted on update.`
//       );
//     } else {
//       alert("Item not found in current sale list.");
//     }
//   };

//   // Add or update medicine to table
//   const addMedicineToTable = () => {
//     const qty = parseInt(selectedMedicine.quantity) || 0;
//     if (!selectedMedicine.stock_id || qty < 1) {
//       alert("Please select a medicine and enter a valid quantity.");
//       return;
//     }

//     if (selectedMedicine.medicine_name === "Consumables") {
//       const mrpVal = parseFloat(selectedMedicine.mrp) || 0;
//       if (mrpVal <= 0) {
//         alert("Please enter a valid price for Consumables.");
//         return;
//       }
//     }

//     // Check stock availability
//     if (
//       selectedMedicine.medicine_name !== "Consumables" &&
//       qty > (selectedMedicine.balance_quantity || 0)
//     ) {
//       if (
//         !window.confirm(
//           `Warning: Requested quantity (${qty}) exceeds available stock (${selectedMedicine.balance_quantity}). This will result in negative stock. Proceed?`
//         )
//       ) {
//         return;
//       }
//     }

//     let updatedMedicines;
//     const mrpVal = parseFloat(selectedMedicine.mrp) || 0;
//     const isEditing = selectedMedicine.originalIndex !== null;
//     const originalIndex = selectedMedicine.originalIndex;
//     const existingMedicineIndex = selectedMedicines.findIndex(
//       (item) =>
//         item.medicine_id === selectedMedicine.medicine_id &&
//         item.batch_no === selectedMedicine.batch_no &&
//         item.unit === selectedMedicine.unit
//     );

//     if (existingMedicineIndex !== -1) {
//       updatedMedicines = [...selectedMedicines];
//       updatedMedicines[existingMedicineIndex].quantity += qty;
//       const subtotal =
//         updatedMedicines[existingMedicineIndex].quantity * mrpVal;
//       const base_price =
//         mrpVal /
//         (1 + updatedMedicines[existingMedicineIndex].gst_percentage / 100);
//       const tax_amount_per_unit = mrpVal - base_price;
//       const tax_amount =
//         updatedMedicines[existingMedicineIndex].quantity * tax_amount_per_unit;
//       updatedMedicines[existingMedicineIndex].gst_percentage =
//         updatedMedicines[existingMedicineIndex].gst_percentage;
//       updatedMedicines[existingMedicineIndex].cgst = tax_amount / 2;
//       updatedMedicines[existingMedicineIndex].sgst = tax_amount / 2;
//       updatedMedicines[existingMedicineIndex].total = subtotal;
//       updatedMedicines[existingMedicineIndex].unit_pack =
//         selectedMedicine.unit_pack;
//       updatedMedicines[existingMedicineIndex].quantity_multiplier =
//         selectedMedicine.quantity_multiplier;
//       if (isEditing && existingMedicineIndex !== originalIndex) {
//         updatedMedicines = updatedMedicines.filter(
//           (_, idx) => idx !== originalIndex
//         );
//       }
//     } else {
//       const subtotal = qty * mrpVal;
//       const base_price = mrpVal / (1 + selectedMedicine.gst_percentage / 100);
//       const tax_amount_per_unit = mrpVal - base_price;
//       const tax_amount = qty * tax_amount_per_unit;
//       updatedMedicines = [
//         ...selectedMedicines,
//         {
//           stock_id: selectedMedicine.stock_id,
//           medicine_id: selectedMedicine.medicine_id,
//           medicine_name: selectedMedicine.medicine_name,
//           batch_no: selectedMedicine.batch_no,
//           expiry_date: selectedMedicine.expiry_date,
//           hsn_code: selectedMedicine.hsn_code,
//           quantity: qty,
//           mrp: mrpVal,
//           gst_percentage: selectedMedicine.gst_percentage,
//           cgst: tax_amount / 2,
//           sgst: tax_amount / 2,
//           total: subtotal,
//           unit: selectedMedicine.unit,
//           unit_pack: selectedMedicine.unit_pack,
//           quantity_multiplier: selectedMedicine.quantity_multiplier,
//         },
//       ];
//       if (isEditing) {
//         updatedMedicines = updatedMedicines.filter(
//           (_, idx) => idx !== originalIndex
//         );
//         updatedMedicines.push({
//           ...updatedMedicines[updatedMedicines.length - 1],
//           stock_id: selectedMedicines[originalIndex].stock_id,
//         });
//       }
//     }

//     setSelectedMedicines(updatedMedicines);

//     setSelectedMedicine({
//       stock_id: "",
//       medicine_id: "",
//       medicine_name: "",
//       hsn_code: "",
//       batch_no: "",
//       balance_quantity: 0,
//       quantity: 0,
//       mrp: 0,
//       gst_percentage: 0,
//       cgst: 0,
//       sgst: 0,
//       expiry_date: "",
//       unit: "",
//       unit_pack: "",
//       quantity_multiplier: 1,
//       originalIndex: null,
//       total: 0,
//     });
//     setMedicineSearch("");
//     setselected_medicine({});
//   };

//   // Update medicine quantity
//   const updateQuantity = (index, newQuantity) => {
//     if (newQuantity < 1) return;
//     const updatedMedicines = [...selectedMedicines];
//     updatedMedicines[index].quantity = parseInt(newQuantity) || 1;
//     const subtotal =
//       updatedMedicines[index].quantity * updatedMedicines[index].mrp || 0;
//     const base_price =
//       updatedMedicines[index].mrp /
//         (1 + updatedMedicines[index].gst_percentage / 100) || 0;
//     const tax_amount_per_unit = updatedMedicines[index].mrp - base_price;
//     const tax_amount = updatedMedicines[index].quantity * tax_amount_per_unit;
//     updatedMedicines[index].cgst = tax_amount / 2 || 0;
//     updatedMedicines[index].sgst = tax_amount / 2 || 0;
//     updatedMedicines[index].total = subtotal || 0;
//     setSelectedMedicines(updatedMedicines);
//   };

//   // Remove medicine from table
//   const removeMedicine = (index) => {
//     const updatedMedicines = selectedMedicines.filter((_, i) => i !== index);
//     setSelectedMedicines(updatedMedicines);
//   };

//   // Handle payment input changes
//   const handlePaymentInputChange = (e) => {
//     const { name, value } = e.target;
//     setPaymentData((prev) => ({ ...prev, [name]: value }));
//   };

//   // Add payment to table
//   const addPaymentToTable = () => {
//     if (!paymentData.pay_type || !paymentData.paid_amount) {
//       alert("Please fill in all payment fields.");
//       return;
//     }
//     const paidAmount = parseFloat(paymentData.paid_amount) || 0;
//     if (paidAmount <= 0) {
//       alert("Paid amount must be greater than zero.");
//       return;
//     }
//     const newPayment = {
//       paid_date: paymentData.paid_date,
//       pay_type: paymentData.pay_type,
//       paid_amount: paidAmount,
//     };
//     setPaymentTableData((prev) => [...prev, newPayment]);
//     setPaymentData({
//       paid_date: new Date().toISOString().split("T")[0],
//       pay_type: "",
//       paid_amount: "",
//     });
//   };

//   // Remove payment from table
//   const removePaymentFromTable = (index) => {
//     const updatedPayments = paymentTableData.filter((_, i) => i !== index);
//     setPaymentTableData(updatedPayments);
//   };

//   // Handle form submission for update
//   const handleSubmit = async () => {
//     if (
//       !formData.invoice_number ||
//       !formData.patient_id ||
//       selectedMedicines.length === 0
//     ) {
//       alert(
//         "Please fill in invoice, patient, and select at least one medicine."
//       );
//       return;
//     }
//     try {
//       const saleData = {
//         sale_date: formData.sale_date,
//         invoice_number: formData.invoice_number,
//         patient_id: formData.patient_id,
//         gst_amount: formData.gst_amount || 0,
//         apply_gst: formData.apply_gst,
//         sub_total: formData.sub_total || 0,
//         discount_percentage: formData.discount_percentage || 0,
//         discount_value: formData.discount_value || 0,
//         net_total: formData.net_total || 0,
//         round_off: formData.round_off || 0,
//         paid: formData.paid || 0,
//         balance: formData.balance || 0,
//         notes: formData.notes || "",
//         payment_type: formData.payment_type || "",
//         sales_list: selectedMedicines.map((item) => ({
//           medicine_id: item.medicine_id || "",
//           medicine_name: item.medicine_name || "",
//           batch_no: item.batch_no || "",
//           hsn_code: item.hsn_code || "",
//           quantity: parseInt(item.quantity) || 0,
//           expiry_date: item.expiry_date || "",
//           mrp: parseFloat(item.mrp) || 0,
//           gst_percentage: parseFloat(item.gst_percentage) || 0,
//           cgst: parseFloat(item.cgst) || 0,
//           sgst: parseFloat(item.sgst) || 0,
//           total: parseFloat(item.total) || 0,
//           unit: item.unit || "",
//           unit_pack: item.unit_pack || "1*1",
//         })),
//       };
//       const response = await axios.put(
//         `${Apiurl}/sale_pharmacy/${id}`,
//         saleData
//       );
//       if (response.status === 200) {
//         if (paymentTableData.length > 0) {
//           const paymentsData = {
//             invoice_number: formData.invoice_number,
//             payments: paymentTableData,
//           };
//           await axios.post(`${Apiurl}/sale_payment_pharmacy`, paymentsData);
//         }
//         alert("Sale updated successfully!");
//         navigate("/pharmacy/sale-pharmacy");
//       } else {
//         alert("Sale update failed. Please try again.");
//       }
//     } catch (error) {
//       console.error("Error updating sale:", error);
//       alert(
//         `Failed to update sale: ${
//           error.response?.data?.message || error.message
//         }`
//       );
//     }
//   };

//   // Handle cancel
//   const handleCancel = () => {
//     navigate("/pharmacy/sale-pharmacy");
//   };

//   // Clear form
//   const handleClearOverAll = () => {
//     const currentInvoiceNumber = formData.invoice_number;
//     setSelectedMedicines([]);
//     setFormData({
//       sale_date: new Date().toISOString().split("T")[0],
//       invoice_number: currentInvoiceNumber,
//       patient_id: "",
//       patient_name: "",
//       mobile: "",
//       discount_percentage: 0,
//       discount_value: 0,
//       apply_gst: true,
//       gst_amount: 0,
//       sub_total: 0,
//       net_total: 0,
//       round_off: 0,
//       paid: 0,
//       balance: 0,
//       notes: "",
//       payment_type: "",
//     });
//     setPatientSearch("");
//     setPaymentTableData([]);
//     setMedicineSearch("");
//     setSelectedMedicine({
//       stock_id: "",
//       medicine_id: "",
//       medicine_name: "",
//       hsn_code: "",
//       batch_no: "",
//       balance_quantity: 0,
//       quantity: 0,
//       mrp: 0,
//       gst_percentage: 0,
//       cgst: 0,
//       sgst: 0,
//       expiry_date: "",
//       unit: "",
//       unit_pack: "",
//       quantity_multiplier: 1,
//       originalIndex: null,
//       total: 0,
//     });
//     setselected_medicine({});
//   };

//   if (isLoading) return <div>Loading...</div>;

//   return (
//     <>
//       <div className="p-3">
//         <div className="row">
//           <div className="col-lg-9 col-xl-9">
//             <div className="card">
//               <div className="card-body py-1 px-3">
//                 <div className="row g-2 align-items-center">
//                   <div className="col-md-6 col-lg-6 col-xl-6">
//                     <label htmlFor="patientId" className="mb-1 fw-bold">
//                       Patient ID
//                     </label>
//                     <div className="position-relative">
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={patientSearch}
//                         onChange={(e) => setPatientSearch(e.target.value)}
//                         onFocus={handlePatientFocus}
//                         onBlur={handlePatientBlur}
//                         placeholder="Search Patient (ID or Name)"
//                         autoComplete="off"
//                       />
//                       <i className="bi bi-caret-down-fill position-absolute end-0 top-50 translate-middle-y me-3"></i>
//                       {showPatientDropdown && (
//                         <div
//                           style={{
//                             position: "absolute",
//                             top: "100%",
//                             zIndex: 1000,
//                             width: "100%",
//                             maxHeight: "200px",
//                             overflowY: "auto",
//                             backgroundColor: "white",
//                             border: "1px solid #ddd",
//                             boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
//                           }}
//                         >
//                           {isLoadingPatients ? (
//                             <div
//                               style={{ padding: "8px", textAlign: "center" }}
//                             >
//                               Loading...
//                             </div>
//                           ) : filteredPatients.length > 0 ? (
//                             filteredPatients.map((patient, index) => (
//                               <div
//                                 key={patient.patient_id || index}
//                                 style={{
//                                   padding: "8px",
//                                   cursor: "pointer",
//                                   borderBottom: "1px solid #eee",
//                                   backgroundColor: "#fff",
//                                 }}
//                                 onMouseDown={(e) => {
//                                   e.preventDefault();
//                                   selectPatient(patient);
//                                 }}
//                               >
//                                 {patient.patient_id} - {patient.first_name}
//                                 <div
//                                   style={{ fontSize: "0.8rem", color: "#666" }}
//                                 >
//                                   {patient.mobile_no}
//                                 </div>
//                               </div>
//                             ))
//                           ) : (
//                             <div
//                               style={{
//                                 padding: "8px",
//                                 color: "#666",
//                                 fontStyle: "italic",
//                               }}
//                             >
//                               No Matching Patients Found
//                             </div>
//                           )}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                   <div className="col-md-3 col-lg-3 col-xl-3">
//                     <label className="mb-1 fw-bold">Patient Name</label>
//                     <input
//                       className="form-control"
//                       type="text"
//                       name="patient_name"
//                       value={formData.patient_name}
//                       onChange={handleInputChange}
//                       placeholder="Enter Patient Name"
//                     />
//                   </div>
//                   <div className="col-md-3 col-lg-3 col-xl-3">
//                     <label className="mb-1 fw-bold">Patient Mobile</label>
//                     <input
//                       className="form-control"
//                       type="text"
//                       name="mobile"
//                       value={formData.mobile}
//                       onChange={handleInputChange}
//                       placeholder="Enter Patient Mobile"
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="col-lg-3 col-xl-3">
//             <div className="card">
//               <div className="card-body py-1 px-3">
//                 <div className="row g-2">
//                   <div className="col-md-6 col-lg-6 col-xl-6">
//                     <label className="mb-1 fw-bold">Date</label>
//                     <input
//                       type="date"
//                       className="form-control"
//                       name="sale_date"
//                       value={formData.sale_date}
//                       onChange={handleInputChange}
//                     />
//                   </div>
//                   <div className="col-md-6 col-lg-6 col-xl-6">
//                     <label className="mb-1 fw-bold">Invoice Number</label>
//                     <input
//                       className="form-control"
//                       type="text"
//                       name="invoice_number"
//                       value={formData.invoice_number}
//                       readOnly
//                       placeholder="Invoice Number"
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className="px-3">
//         <div className="row">
//           <div className="col-md-8 col-lg-9 col-xl-9">
//             <div className="border rounded p-3 bg-white">
//               <div className="row">
//                 <div className="col-md-4 col-lg-4 col-xl-4 mb-2">
//                   <label className="form-label fw-bold">Medicine Name</label>
//                   <div className="position-relative">
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={medicineSearch}
//                       onChange={(e) => setMedicineSearch(e.target.value)}
//                       onFocus={handleMedicineFocus}
//                       onBlur={handleMedicineBlur}
//                       placeholder="Search Medicine, Batch, or HSN"
//                     />
//                     <i className="bi bi-caret-down-fill position-absolute end-0 top-50 translate-middle-y me-3"></i>
//                     {showMedicineDropdown && (
//                       <div
//                         style={{
//                           position: "absolute",
//                           top: "100%",
//                           zIndex: 1000,
//                           width: "100%",
//                           maxHeight: "200px",
//                           overflowY: "auto",
//                           backgroundColor: "white",
//                           border: "1px solid #ddd",
//                           boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
//                         }}
//                       >
//                         {filteredMedicines.length > 0 ? (
//                           filteredMedicines.map((medicine, index) => (
//                             <div
//                               key={medicine._id || index}
//                               style={{
//                                 padding: "8px",
//                                 cursor: "pointer",
//                                 borderBottom: "1px solid #eee",
//                                 backgroundColor: "#fff",
//                               }}
//                               onMouseDown={(e) => {
//                                 e.preventDefault();
//                                 selectMedicine(medicine);
//                               }}
//                             >
//                               {medicine.medicine_details?.medicine_name ||
//                                 medicine.medicine_details?.[0]?.medicine_name ||
//                                 "Unknown"}
//                               <div
//                                 style={{ fontSize: "0.8rem", color: "#666" }}
//                               >
//                                 Batch: {medicine.batch_no || "N/A"} | HSN:{" "}
//                                 {medicine.medicine_details?.hsn_code ||
//                                   medicine.medicine_details?.[0]?.hsn_code ||
//                                   "N/A"}{" "}
//                                 | Avl: {medicine.balance_quantity || 0} | Rs.{" "}
//                                 {(parseFloat(medicine.mrp) || 0).toFixed(2)} |
//                                 GST: {medicine.gst_percentage || "0"}%
//                               </div>
//                             </div>
//                           ))
//                         ) : (
//                           <div
//                             style={{
//                               padding: "8px",
//                               color: "#666",
//                               fontStyle: "italic",
//                             }}
//                           >
//                             No Matching Medicines Found
//                           </div>
//                         )}
//                       </div>
//                     )}
//                   </div>
//                 </div>
//                 <div className="col-md-2 col-lg-2 col-xl-2 mb-2">
//                   <label className="form-label fw-bold">Qty</label>
//                   <input
//                     type="number"
//                     className="form-control"
//                     name="quantity"
//                     value={selectedMedicine.quantity}
//                     onChange={handleMedicineInputChange}
//                     placeholder="Quantity"
//                   />
//                 </div>
//                 <div className="col-md-2 col-lg-2 col-xl-2 mb-2">
//                   <label className="form-label fw-bold">Unit</label>
//                   <select
//                     className="form-control"
//                     name="unit"
//                     value={selectedMedicine.unit}
//                     onChange={handleMedicineInputChange}
//                   >
//                     <option value="">Select Unit</option>
//                     <option value="Tablet">Tablet</option>
//                     <option value="Pack">Pack</option>
//                     <option value="Per Piece">Per Piece</option>
//                     <option value="Bottle">Bottle</option>
//                     <option value="Strip">Strip</option>
//                     {selectedMedicine.medicine_name === "Consumables" && (
//                       <option value="Other">Other</option>
//                     )}
//                   </select>
//                 </div>
//                 <div className="col-md-2 col-lg-2 col-xl-2 mb-2">
//                   <label className="form-label fw-bold">Price</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     name="mrp"
//                     value={
//                       selectedMedicine.medicine_name === "Consumables"
//                         ? selectedMedicine.mrp || ""
//                         : selectedMedicine.mrp
//                         ? parseFloat(selectedMedicine.mrp).toFixed(2)
//                         : ""
//                     }
//                     readOnly={selectedMedicine.medicine_name !== "Consumables"}
//                     onChange={handleMedicineInputChange}
//                   />
//                 </div>
//                 <div className="col-md-1 col-lg-1 col-xl-1 mt-4">
//                   <button
//                     type="button"
//                     className="btn btn-sm btn-success w-100"
//                     onClick={addMedicineToTable}
//                   >
//                     {selectedMedicine.originalIndex !== null ? "Update" : "+"}
//                   </button>
//                 </div>
//               </div>
//               <div className="table-responsive table-scroll-350">
//                 <table className="table table-bordered mb-0">
//                   <thead className="text-center">
//                     <tr>
//                       {[
//                         "S.no",
//                         "Medicine Name",
//                         "Qty",
//                         "Unit",
//                         "Price",
//                         "GST %",
//                         "Amount",
//                         "Action",
//                       ].map((h, idx) => (
//                         <th
//                           key={idx}
//                           style={{
//                             backgroundColor: "#01AEBE",
//                             color: "white",
//                           }}
//                         >
//                           {h}
//                         </th>
//                       ))}
//                     </tr>
//                   </thead>
//                   <tbody className="text-center">
//                     {selectedMedicines.length > 0 ? (
//                       selectedMedicines.map((item, index) => (
//                         <tr key={item.stock_id || index}>
//                           <td>{index + 1}</td>
//                           <td>{item.medicine_name || "N/A"}</td>
//                           <td>
//                             <div className="d-flex justify-content-center gap-1">
//                               <input
//                                 type="number"
//                                 className="form-control form-control-sm text-center"
//                                 style={{ width: "60px" }}
//                                 value={item.quantity || 0}
//                                 onChange={(e) =>
//                                   updateQuantity(
//                                     index,
//                                     parseInt(e.target.value) || 1
//                                   )
//                                 }
//                               />
//                             </div>
//                           </td>
//                           <td>{item.unit || "N/A"}</td>
//                           <td>{(parseFloat(item.mrp) || 0).toFixed(2)}</td>
//                           <td>{parseFloat(item.gst_percentage) || 0}%</td>
//                           <td>{(parseFloat(item.total) || 0).toFixed(2)}</td>
//                           <td className="d-flex justify-content-center gap-1">
//                             <button
//                               className="btn btn-sm p-1 border-0"
//                               style={{ backgroundColor: "transparent" }}
//                               onClick={() => editMedicine(item, index)}
//                             >
//                               <Edit size={16} className="text-primary" />
//                             </button>
//                             <button
//                               className="btn btn-sm p-1 border-0"
//                               style={{ backgroundColor: "transparent" }}
//                               onClick={() => removeMedicine(index)}
//                             >
//                               <Trash2 size={16} className="text-danger" />
//                             </button>
//                             <button
//                               className="btn btn-sm p-1 border-0"
//                               style={{ backgroundColor: "transparent" }}
//                               onClick={() => handleReturnClick(item)}
//                             >
//                               <ArrowLeftRight
//                                 size={18}
//                                 className="text-primary"
//                               />
//                             </button>
//                           </td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan="8" className="text-center">
//                           No medicines selected
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           </div>
//           <div className="col-md-4 col-lg-3 col-xl-3">
//             <div className="row card card-body">
//               <div className="row">
//                 <div className="col-5 col-md-5 col-lg-5 col-xl-5">
//                   <label className="text-dark fw-bold">Sub Total</label>
//                 </div>
//                 <div className="col-7 col-md-7 col-lg-7 col-xl-7">
//                   <input
//                     type="text"
//                     className="form-control form-control-sm"
//                     value={(parseFloat(formData.sub_total) || 0).toFixed(2)}
//                     readOnly
//                   />
//                 </div>
//               </div>
//               <div className="row">
//                 <div className="col-5 col-md-5 col-lg-5 col-xl-5">
//                   <label className="fw-bold">Discount</label>
//                 </div>
//                 <div className="col-7 col-md-7 col-lg-7 col-xl-7">
//                   <input
//                     type="number"
//                     className="form-control form-control-sm"
//                     name="discount_percentage"
//                     value={formData.discount_percentage || 0}
//                     onChange={handleInputChange}
//                     placeholder="Discount %"
//                   />
//                 </div>
//               </div>
//               <div className="row">
//                 <div className="col-5 col-md-5 col-lg-5 col-xl-5">
//                   <label className="fw-bold">Tax</label>
//                 </div>
//                 <div className="col-7 col-md-7 col-lg-7 col-xl-7">
//                   <input
//                     type="text"
//                     className="form-control form-control-sm"
//                     value={(parseFloat(formData.gst_amount) || 0).toFixed(2)}
//                     readOnly
//                     placeholder="Tax Amount"
//                   />
//                 </div>
//               </div>
//               <div style={{ backgroundColor: "#01AEBE" }}>
//                 <div className="row pt-3 pb-0 p-2">
//                   <label className="col-5 fs-5 col-form-label pt-3 text-white fw-bold">
//                     Net Total
//                   </label>
//                   <div className="col-7">
//                     <input
//                       type="text"
//                       className="form-control text-end fs-4 fw-bold text-primary"
//                       value={(parseFloat(formData.net_total) || 0).toFixed(2)}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//               </div>
//               <div className="row mt-3">
//                 <div className="col-5 col-md-5 col-lg-5 col-xl-5">
//                   <label className="fw-bold">Payment Type</label>
//                 </div>
//                 <div className="col-7 col-md-7 col-lg-7 col-xl-7">
//                   <select
//                     className="form-control"
//                     name="payment_type"
//                     value={formData.payment_type || ""}
//                     onChange={handleInputChange}
//                   >
//                     <option value="">Select Payment Type</option>
//                     <option value="Cash">Cash</option>
//                     <option value="Card">Card</option>
//                   </select>
//                 </div>
//               </div>
//               <div className="row mb-2">
//                 <button
//                   type="button"
//                   className="btn btn-lg fw-bold btn-success fs-5 w-100"
//                   onClick={() => setShowAddModal(true)}
//                 >
//                   Pay
//                 </button>
//               </div>
//               <div className="row mt-2">
//                 <div className="col-5 col-md-5 col-lg-5 col-xl-5">
//                   <label className="fw-bold">Paid</label>
//                 </div>
//                 <div className="col-7 col-md-7 col-lg-7 col-xl-7">
//                   <input
//                     type="text"
//                     className="form-control form-control-sm"
//                     value={(parseFloat(formData.paid) || 0).toFixed(2)}
//                     readOnly
//                   />
//                 </div>
//               </div>
//               <div className="row">
//                 <div className="col-5 col-md-5 col-lg-5 col-xl-5">
//                   <label className="fw-bold">Balance</label>
//                 </div>
//                 <div className="col-7 col-md-7 col-lg-7 col-xl-7">
//                   <input
//                     type="text"
//                     className="form-control form-control-sm"
//                     value={(parseFloat(formData.balance) || 0).toFixed(2)}
//                     readOnly
//                   />
//                 </div>
//               </div>
//               <div className="row text-center mt-3">
//                 <div className="col-4">
//                   <button
//                     className="btn btn-sm btn-secondary w-100"
//                     onClick={handleClearOverAll}
//                   >
//                     Clear
//                   </button>
//                 </div>
//                 <div className="col-4">
//                   <button
//                     className="btn btn-sm btn-success w-100"
//                     onClick={handleSubmit}
//                   >
//                     Update
//                   </button>
//                 </div>
//                 <div className="col-4">
//                   <button
//                     className="btn btn-sm btn-danger w-100"
//                     onClick={handleCancel}
//                   >
//                     Back
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       {/* Payment Modal */}
//       <div
//         className={`modal fade ${showAddModal ? "show d-block" : ""}`}
//         tabIndex="-1"
//         aria-labelledby="addPaymentModalLabel"
//         aria-hidden={!showAddModal}
//         style={{
//           backgroundColor: "rgba(0,0,0,0.5)",
//           transition: "opacity 0.3s ease-in-out",
//         }}
//       >
//         <div className="modal-dialog modal-xl modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title fw-bold" id="addPaymentModalLabel">
//                 Add Payment Details
//               </h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 onClick={() => setShowAddModal(false)}
//               ></button>
//             </div>
//             <div className="modal-body">
//               <div className="row">
//                 <div className="col-lg-2 mb-2">
//                   <label className="form-label fw-bold">Date</label>
//                   <input
//                     type="date"
//                     className="form-control"
//                     name="paid_date"
//                     value={paymentData.paid_date || ""}
//                     onChange={handlePaymentInputChange}
//                   />
//                 </div>
//                 <div className="col-lg-2 mb-2">
//                   <label className="form-label fw-bold">Total Amount</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={(parseFloat(formData.net_total) || 0).toFixed(2)}
//                     readOnly
//                   />
//                 </div>
//                 <div className="col-lg-2 mb-2">
//                   <label className="form-label fw-bold">Payment Type</label>
//                   <div className="position-relative">
//                     <select
//                       className="form-control"
//                       name="pay_type"
//                       value={paymentData.pay_type || ""}
//                       onChange={handlePaymentInputChange}
//                     >
//                       <option value="">Payment Type</option>
//                       <option value="Cash">Cash</option>
//                       <option value="Card">Card</option>
//                       <option value="Gpay">Gpay</option>
//                       <option value="Phonepe">Phonepe</option>
//                       <option value="Paytm">Paytm</option>
//                       <option value="Amazon Pay">Amazon Pay</option>
//                       <option value="UPI">UPI</option>
//                     </select>
//                     <i className="bi bi-caret-down-fill position-absolute end-0 top-50 translate-middle-y me-3"></i>
//                   </div>
//                 </div>
//                 <div className="col-lg-2 mb-2">
//                   <label className="form-label fw-bold">Paid Amount</label>
//                   <input
//                     type="number"
//                     className="form-control"
//                     name="paid_amount"
//                     value={paymentData.paid_amount || ""}
//                     onChange={handlePaymentInputChange}
//                     placeholder="Enter Paid Amount"
//                   />
//                 </div>
//                 <div className="col-lg-2 mb-2">
//                   <label className="form-label fw-bold">Balance Amount</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     value={(parseFloat(formData.balance) || 0).toFixed(2)}
//                     readOnly
//                   />
//                 </div>
//                 <div className="col-lg-2 mb-2 d-flex align-items-end">
//                   <button
//                     type="button"
//                     className="btn btn-success w-100"
//                     onClick={addPaymentToTable}
//                   >
//                     ADD
//                   </button>
//                 </div>
//               </div>
//               <div className="table-responsive mt-3">
//                 <table className="table table-bordered">
//                   <thead className="text-center">
//                     <tr>
//                       {[
//                         "S.no",
//                         "Paid Date",
//                         "Pay Type",
//                         "Amount",
//                         "Action",
//                       ].map((h, idx) => (
//                         <th
//                           key={idx}
//                           style={{
//                             backgroundColor: "#01AEBE",
//                             color: "white",
//                           }}
//                         >
//                           {h}
//                         </th>
//                       ))}
//                     </tr>
//                   </thead>
//                   <tbody className="text-center">
//                     {paymentTableData.length > 0 ? (
//                       paymentTableData.map((item, index) => (
//                         <tr key={item.id || index}>
//                           <td>{index + 1}</td>
//                           <td>{item.paid_date || "N/A"}</td>
//                           <td>{item.pay_type || "N/A"}</td>
//                           <td>
//                             {(parseFloat(item.paid_amount) || 0).toFixed(2)}
//                           </td>
//                           <td className="d-flex justify-content-center gap-1">
//                             <button
//                               className="btn btn-sm p-1 border-0"
//                               style={{ backgroundColor: "transparent" }}
//                               onClick={() => removePaymentFromTable(index)}
//                             >
//                               <Trash2 size={16} className="text-danger" />
//                             </button>
//                           </td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan="5" className="text-center">
//                           No payments added
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default UpdateSalePharmacy;

import React, { useEffect, useState } from "react";
import { Edit, Trash2, ArrowLeftRight } from "lucide-react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Apiurl from "../../environment/Apiurl";

const UpdateSalePharmacy = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [showAddModal, setShowAddModal] = useState(false);
  const [responseData, setResponseData] = useState([]);
  const [responsePatientData, setResponsePatientData] = useState([]);
  const [selectedMedicines, setSelectedMedicines] = useState([]);
  const [medicineSearch, setMedicineSearch] = useState("");
  const [patientSearch, setPatientSearch] = useState("");
  const [showMedicineDropdown, setShowMedicineDropdown] = useState(false);
  const [showPatientDropdown, setShowPatientDropdown] = useState(false);
  const [isLoadingPatients, setIsLoadingPatients] = useState(false);
  const [formData, setFormData] = useState({
    sale_date: new Date().toISOString().split("T")[0],
    invoice_number: "",
    patient_id: "",
    patient_name: "",
    mobile: "",
    discount_percentage: 0,
    discount_value: 0,
    apply_gst: true,
    gst_amount: 0,
    sub_total: 0,
    net_total: 0,
    round_off: 0,
    paid: 0,
    balance: 0,
    notes: "",
    payment_type: "",
  });
  const [paymentData, setPaymentData] = useState({
    paid_date: new Date().toISOString().split("T")[0],
    pay_type: "",
    paid_amount: "",
  });
  const [paymentTableData, setPaymentTableData] = useState([]);
  const [selectedMedicine, setSelectedMedicine] = useState({
    stock_id: "",
    medicine_id: "",
    medicine_name: "",
    hsn_code: "",
    batch_no: "",
    balance_quantity: 0,
    quantity: 0,
    mrp: 0,
    gst_percentage: 0,
    cgst: 0,
    sgst: 0,
    expiry_date: "",
    unit: "",
    unit_pack: "",
    quantity_multiplier: 1,
    originalIndex: null,
    total: 0,
    returned_quantity: 0,
  });
  const [selected_medicine, setselected_medicine] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  // Fetch medicines from API
  const fetchResponse = async () => {
    try {
      const response = await axios.get(`${Apiurl}/stock_pharmacy`);
      setResponseData(response.data || []);
    } catch (error) {
      console.error("Error fetching medicines:", error.message);
    }
  };

  // Fetch patients from API
  const fetchResponsePatient = async () => {
    setIsLoadingPatients(true);
    try {
      const response = await axios.get(`${Apiurl}/patient_details`);
      setResponsePatientData(response.data || []);
    } catch (error) {
      console.error("Error fetching patients:", error.message);
    } finally {
      setIsLoadingPatients(false);
    }
  };

  // Fetch existing sale data
  const fetchSaleData = async () => {
    try {
      const response = await axios.get(`${Apiurl}/sale_pharmacy/${id}`);
      const sale = response.data;

      console.log(
        "Fetched sales_list with returned_quantity:",
        sale.sales_list
      );

      setFormData({
        sale_date: sale.sale_date.split("T")[0],
        invoice_number: sale.invoice_number || "",
        patient_id: sale.patient_id || "",
        patient_name: sale.patient_details[0]?.first_name || "",
        mobile: sale.patient_details[0]?.mobile_no || "",
        discount_percentage: parseFloat(sale.discount_percentage) || 0,
        discount_value: parseFloat(sale.discount_value) || 0,
        apply_gst: sale.apply_gst !== undefined ? sale.apply_gst : true,
        gst_amount: parseFloat(sale.gst_amount) || 0,
        sub_total: parseFloat(sale.sub_total) || 0,
        net_total: parseFloat(sale.net_total) || 0,
        round_off: parseFloat(sale.round_off) || 0,
        paid: parseFloat(sale.paid) || 0,
        balance: parseFloat(sale.balance) || 0,
        notes: sale.notes || "",
        payment_type: sale.payment_type || "",
      });

      setPatientSearch(
        `${sale.patient_id} - ${sale.patient_details[0]?.first_name || ""}`
      );

      // IMPORTANT: Ensure returned_quantity is properly preserved from API response
      const medicines = sale.sales_list.map((item) => ({
        stock_id: item.stock_id || "",
        medicine_id: item.medicine_id || "",
        medicine_name:
          item.medicine_details?.medicine_name || item.medicine_name || "",
        hsn_code: item.hsn_code || "",
        batch_no: item.batch_no || "",
        balance_quantity: parseInt(item.balance_quantity) || 0,
        quantity: parseInt(item.quantity) || 0,
        mrp: parseFloat(item.mrp) || 0,
        gst_percentage: parseFloat(item.gst_percentage) || 0,
        cgst: parseFloat(item.cgst) || 0,
        sgst: parseFloat(item.sgst) || 0,
        expiry_date: item.expiry_date || "",
        unit: item.unit || "",
        unit_pack: item.unit_pack || "1*1",
        total: parseFloat(item.total) || 0,
        quantity_multiplier: parseFloat(item.quantity_multiplier) || 1,
        returned_quantity: parseInt(item.returned_quantity) || 0, // Ensure this is preserved
      }));

      console.log("Processed medicines with returned_quantity:", medicines);
      setSelectedMedicines(medicines);

      const payments = sale.sales_pharmacy_payment.map((payment) => ({
        id: payment._id || "",
        paid_date: payment.paid_date.split("T")[0] || "",
        pay_type: payment.pay_type || "",
        paid_amount: parseFloat(payment.paid_amount) || 0,
      }));

      setPaymentTableData(payments);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching sale data:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchResponse();
    fetchResponsePatient();
    fetchSaleData();
  }, [id]);

  // Recalculate totals whenever selectedMedicines or paymentTableData changes
  useEffect(() => {
    setFormData((prev) => recalculateFormTotals(prev));
  }, [selectedMedicines, paymentTableData]);

  // Recalculate form totals
  const recalculateFormTotals = (formState) => {
    const subTotal = selectedMedicines.reduce((sum, item) => {
      const mrp = parseFloat(item.mrp) || 0;
      const quantity = parseInt(item.quantity) || 0;
      const cgst = parseFloat(item.cgst) || 0;
      const sgst = parseFloat(item.sgst) || 0;
      return sum + quantity * mrp - (cgst + sgst);
    }, 0);

    const discountPercentage = parseFloat(formState.discount_percentage) || 0;
    const discountValue = (subTotal * discountPercentage) / 100;
    const gstAmount = formState.apply_gst
      ? selectedMedicines.reduce((sum, item) => {
          const cgst = parseFloat(item.cgst) || 0;
          const sgst = parseFloat(item.sgst) || 0;
          return sum + (cgst + sgst);
        }, 0)
      : 0;

    const netTotal = subTotal - discountValue + gstAmount;
    const netTotalDecimal = netTotal % 1;
    let roundOff = 0;
    let roundedNetTotal = netTotal;

    if (netTotalDecimal >= 0.5) {
      roundedNetTotal = Math.ceil(netTotal);
      roundOff = roundedNetTotal - netTotal;
    } else {
      roundedNetTotal = Math.floor(netTotal);
      roundOff = roundedNetTotal - netTotal;
    }

    const paid = paymentTableData.reduce(
      (sum, item) => sum + (parseFloat(item.paid_amount) || 0),
      0
    );
    const balance = roundedNetTotal - paid;

    return {
      ...formState,
      sub_total: subTotal || 0,
      discount_value: discountValue || 0,
      gst_amount: gstAmount || 0,
      net_total: roundedNetTotal || 0,
      round_off: roundOff || 0,
      paid: paid || 0,
      balance: balance || 0,
    };
  };

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => {
      const newData = {
        ...prev,
        [name]: type === "checkbox" ? checked : value,
        [name]:
          name === "discount_percentage"
            ? Math.max(parseFloat(value) || 0, 0)
            : value,
      };
      if (name === "discount_percentage" || name === "apply_gst") {
        return recalculateFormTotals(newData);
      }
      return newData;
    });
  };

  // Handle patient search and dropdown
  const handlePatientFocus = () => setShowPatientDropdown(true);
  const handlePatientBlur = () => {
    setTimeout(() => setShowPatientDropdown(false), 200);
  };

  const filteredPatients = responsePatientData.filter((patient) =>
    `${patient.patient_id} ${patient.first_name}`
      .toLowerCase()
      .includes(patientSearch.toLowerCase())
  );

  const selectPatient = (patient) => {
    setFormData((prev) => ({
      ...prev,
      patient_id: patient.patient_id || "",
      patient_name: patient.first_name || "",
      mobile: patient.mobile_no || "",
    }));
    setPatientSearch(`${patient.patient_id} - ${patient.first_name}`);
    setShowPatientDropdown(false);
  };

  // Handle medicine search and dropdown
  const handleMedicineFocus = () => setShowMedicineDropdown(true);
  const handleMedicineBlur = () => {
    setTimeout(() => setShowMedicineDropdown(false), 200);
  };

  const filteredMedicines = responseData.filter((item) => {
    const medicineName =
      item.medicine_details?.medicine_name ||
      item.medicine_details?.[0]?.medicine_name ||
      "";
    const batchNo = item.batch_no || "";
    const hsnCode =
      item.medicine_details?.hsn_code ||
      item.medicine_details?.[0]?.hsn_code ||
      "";
    const balanceQuantity = item.balance_quantity || 0;
    const searchText = `${medicineName} ${batchNo} ${hsnCode}`.toLowerCase();
    return (
      (searchText.includes(medicineSearch.toLowerCase()) &&
        balanceQuantity > 0) ||
      medicineName === "Consumables"
    );
  });

  const selectMedicine = (medicine) => {
    const medicineName =
      medicine.medicine_details?.medicine_name ||
      medicine.medicine_details?.[0]?.medicine_name ||
      "Unknown";
    const hsnCode =
      medicine.medicine_details?.hsn_code ||
      medicine.medicine_details?.[0]?.hsn_code ||
      "";
    const unitPack =
      medicine.medicine_details?.unit_pack ||
      medicine.medicine_details?.[0]?.unit_pack ||
      "";

    const isConsumables = medicineName === "Consumables";
    let initialQuantity = isConsumables ? "" : 1;
    let initialMrp = isConsumables ? "" : parseFloat(medicine.mrp) || 0;
    let initialGst = parseFloat(medicine.gst_percentage || 0);
    let initialCgst = 0;
    let initialSgst = 0;

    if (!isConsumables) {
      const basePrice = initialMrp / (1 + initialGst / 100);
      const taxAmountPerUnit = initialMrp - basePrice;
      const taxAmount = initialQuantity * taxAmountPerUnit;
      initialCgst = taxAmount / 2;
      initialSgst = taxAmount / 2;
    }

    setselected_medicine(medicine);

    setSelectedMedicine({
      stock_id: medicine._id,
      medicine_id: medicine.medicine_id,
      batch_no: medicine.batch_no || "",
      balance_quantity: medicine.balance_quantity || 0,
      quantity: initialQuantity,
      mrp: initialMrp,
      gst_percentage: initialGst,
      cgst: initialCgst,
      sgst: initialSgst,
      expiry_date: medicine.expiry_date || "",
      unit_pack: medicine.unit_pack,
      medicine_name: medicineName,
      hsn_code: hsnCode,
      unit: isConsumables ? "Other" : "",
      quantity_multiplier: 1,
      originalIndex: null,
      total: isConsumables ? 0 : initialMrp,
      returned_quantity: 0, // Always start with 0 for new medicine
    });

    setMedicineSearch(medicineName);
    setShowMedicineDropdown(false);
  };

  // Handle medicine input changes
  const handleMedicineInputChange = (e) => {
    const { name, value } = e.target;
    const isConsumables = selectedMedicine.medicine_name === "Consumables";
    let mrp_rate = selected_medicine.mrp || 0;
    let quantity_multiplier = 1;

    if (
      !isConsumables &&
      name === "unit" &&
      (value === "Tablet" || value === "Bottle" || value === "Per Piece") &&
      selected_medicine.unit_pack?.includes("*")
    ) {
      const qty_per_unit = selected_medicine.unit_pack.split("*");
      if (qty_per_unit[1] && !isNaN(parseFloat(qty_per_unit[1]))) {
        mrp_rate =
          parseFloat(selected_medicine.mrp) / parseFloat(qty_per_unit[1]);
      }
    } else if (
      !isConsumables &&
      name === "unit" &&
      (value === "Strip" || value === "Pack") &&
      selected_medicine.unit_pack?.includes("*")
    ) {
      const qty_per_unit = selected_medicine.unit_pack.split("*");
      if (qty_per_unit[1] && !isNaN(parseFloat(qty_per_unit[1]))) {
        quantity_multiplier = parseFloat(qty_per_unit[1]);
      }
    }

    setSelectedMedicine((prev) => {
      let updatedMedicine = { ...prev };

      if (name === "quantity") {
        updatedMedicine[name] = parseInt(value) || 0;
      } else if (name === "mrp" && isConsumables) {
        updatedMedicine[name] = parseFloat(value) || 0;
      } else {
        updatedMedicine[name] = value;
      }

      if (name === "unit" && !isConsumables) {
        updatedMedicine.mrp = parseFloat(mrp_rate);
        updatedMedicine.quantity_multiplier = quantity_multiplier;
      }

      // Recalculate tax-related fields
      const currentMrp = parseFloat(updatedMedicine.mrp) || 0;
      const currentGst = parseFloat(updatedMedicine.gst_percentage) || 0;
      const currentQty = parseInt(updatedMedicine.quantity) || 0;
      const base_price = currentMrp / (1 + currentGst / 100);
      const tax_amount_per_unit = currentMrp - base_price;
      const tax_amount = currentQty * tax_amount_per_unit;

      const finalMedicine = {
        ...updatedMedicine,
        cgst: tax_amount / 2,
        sgst: tax_amount / 2,
        total: currentQty * currentMrp,
      };
      return finalMedicine;
    });
  };

  // Edit medicine - IMPORTANT: Preserve returned_quantity when editing
  const editMedicine = (medicine, index) => {
    const stockData = responseData.find(
      (item) =>
        item.medicine_id === medicine.medicine_id &&
        item.batch_no === medicine.batch_no
    );

    if (stockData) {
      setselected_medicine(stockData);
    }

    setSelectedMedicine({
      ...medicine,
      balance_quantity:
        responseData.find((m) => m._id === medicine.stock_id)
          ?.balance_quantity || 0,
      quantity_multiplier: parseFloat(medicine.quantity_multiplier) || 1,
      originalIndex: index,
      returned_quantity: medicine.returned_quantity || 0, // Preserve returned_quantity
    });

    setMedicineSearch(medicine.medicine_name || "");
  };

  // Handle return click for medicine - UPDATED to properly handle returns
  const handleReturnClick = (item) => {
    const currentSold = item.quantity + (item.returned_quantity || 0);
    const returnQtyInput = prompt(
      `Enter return quantity for ${
        item.medicine_name
      } (original sold: ${currentSold}, already returned: ${
        item.returned_quantity || 0
      })`
    );

    if (
      !returnQtyInput ||
      isNaN(returnQtyInput) ||
      parseInt(returnQtyInput) <= 0
    ) {
      return;
    }

    const returnQty = parseInt(returnQtyInput);
    if (returnQty > currentSold) {
      alert("Cannot return more than the original sold quantity.");
      return;
    }

    // Find the index in selectedMedicines
    const index = selectedMedicines.findIndex(
      (m) =>
        m.medicine_id === item.medicine_id &&
        m.batch_no === item.batch_no &&
        m.unit === item.unit
    );

    if (index !== -1) {
      const newReturned = (item.returned_quantity || 0) + returnQty;
      const remainingSold = currentSold - newReturned;

      const updatedMedicines = [...selectedMedicines];
      updatedMedicines[index].returned_quantity = newReturned;
      updatedMedicines[index].quantity = remainingSold;

      // Recalculate totals for this item
      const subtotal = remainingSold * updatedMedicines[index].mrp;
      const base_price =
        updatedMedicines[index].mrp /
        (1 + updatedMedicines[index].gst_percentage / 100);
      const tax_amount_per_unit = updatedMedicines[index].mrp - base_price;
      const tax_amount = remainingSold * tax_amount_per_unit;

      updatedMedicines[index].cgst = tax_amount / 2;
      updatedMedicines[index].sgst = tax_amount / 2;
      updatedMedicines[index].total = subtotal;

      setSelectedMedicines(updatedMedicines);

      alert(
        `Returned ${returnQty} units. Total returned: ${newReturned}. Remaining sold: ${remainingSold}. Stock will be adjusted on update.`
      );
    } else {
      alert("Item not found in current sale list.");
    }
  };

  // Add or update medicine to table - UPDATED to preserve returned_quantity
  const addMedicineToTable = () => {
    const qty = parseInt(selectedMedicine.quantity) || 0;
    if (!selectedMedicine.stock_id || qty < 1) {
      alert("Please select a medicine and enter a valid quantity.");
      return;
    }

    if (selectedMedicine.medicine_name === "Consumables") {
      const mrpVal = parseFloat(selectedMedicine.mrp) || 0;
      if (mrpVal <= 0) {
        alert("Please enter a valid price for Consumables.");
        return;
      }
    }

    // Check stock availability
    if (
      selectedMedicine.medicine_name !== "Consumables" &&
      qty > (selectedMedicine.balance_quantity || 0)
    ) {
      if (
        !window.confirm(
          `Warning: Requested quantity (${qty}) exceeds available stock (${selectedMedicine.balance_quantity}). This will result in negative stock. Proceed?`
        )
      ) {
        return;
      }
    }

    let updatedMedicines;
    const mrpVal = parseFloat(selectedMedicine.mrp) || 0;
    const isEditing = selectedMedicine.originalIndex !== null;
    const originalIndex = selectedMedicine.originalIndex;
    const existingMedicineIndex = selectedMedicines.findIndex(
      (item) =>
        item.medicine_id === selectedMedicine.medicine_id &&
        item.batch_no === selectedMedicine.batch_no &&
        item.unit === selectedMedicine.unit
    );

    if (existingMedicineIndex !== -1) {
      updatedMedicines = [...selectedMedicines];

      // Preserve returned_quantity when updating existing medicine
      const existingReturnedQty =
        updatedMedicines[existingMedicineIndex].returned_quantity || 0;

      updatedMedicines[existingMedicineIndex].quantity += qty;
      const subtotal =
        updatedMedicines[existingMedicineIndex].quantity * mrpVal;
      const base_price =
        mrpVal /
        (1 + updatedMedicines[existingMedicineIndex].gst_percentage / 100);
      const tax_amount_per_unit = mrpVal - base_price;
      const tax_amount =
        updatedMedicines[existingMedicineIndex].quantity * tax_amount_per_unit;

      updatedMedicines[existingMedicineIndex].gst_percentage =
        updatedMedicines[existingMedicineIndex].gst_percentage;
      updatedMedicines[existingMedicineIndex].cgst = tax_amount / 2;
      updatedMedicines[existingMedicineIndex].sgst = tax_amount / 2;
      updatedMedicines[existingMedicineIndex].total = subtotal;
      updatedMedicines[existingMedicineIndex].unit_pack =
        selectedMedicine.unit_pack;
      updatedMedicines[existingMedicineIndex].quantity_multiplier =
        selectedMedicine.quantity_multiplier;
      updatedMedicines[existingMedicineIndex].returned_quantity =
        existingReturnedQty; // Preserve returned quantity

      if (isEditing && existingMedicineIndex !== originalIndex) {
        updatedMedicines = updatedMedicines.filter(
          (_, idx) => idx !== originalIndex
        );
      }
    } else {
      const subtotal = qty * mrpVal;
      const base_price = mrpVal / (1 + selectedMedicine.gst_percentage / 100);
      const tax_amount_per_unit = mrpVal - base_price;
      const tax_amount = qty * tax_amount_per_unit;

      updatedMedicines = [
        ...selectedMedicines,
        {
          stock_id: selectedMedicine.stock_id,
          medicine_id: selectedMedicine.medicine_id,
          medicine_name: selectedMedicine.medicine_name,
          batch_no: selectedMedicine.batch_no,
          expiry_date: selectedMedicine.expiry_date,
          hsn_code: selectedMedicine.hsn_code,
          quantity: qty,
          mrp: mrpVal,
          gst_percentage: selectedMedicine.gst_percentage,
          cgst: tax_amount / 2,
          sgst: tax_amount / 2,
          total: subtotal,
          unit: selectedMedicine.unit,
          unit_pack: selectedMedicine.unit_pack,
          quantity_multiplier: selectedMedicine.quantity_multiplier,
          returned_quantity: selectedMedicine.returned_quantity || 0, // Include returned_quantity
        },
      ];

      if (isEditing) {
        // When editing, preserve the returned_quantity from the original item
        const originalReturnedQty =
          selectedMedicines[originalIndex].returned_quantity || 0;
        updatedMedicines = updatedMedicines.filter(
          (_, idx) => idx !== originalIndex
        );

        // Add the updated medicine with preserved returned_quantity
        updatedMedicines.push({
          ...updatedMedicines[updatedMedicines.length - 1],
          stock_id: selectedMedicines[originalIndex].stock_id,
          returned_quantity: originalReturnedQty, // Preserve returned_quantity
        });
      }
    }

    setSelectedMedicines(updatedMedicines);

    // Reset selected medicine form
    setSelectedMedicine({
      stock_id: "",
      medicine_id: "",
      medicine_name: "",
      hsn_code: "",
      batch_no: "",
      balance_quantity: 0,
      quantity: 0,
      mrp: 0,
      gst_percentage: 0,
      cgst: 0,
      sgst: 0,
      expiry_date: "",
      unit: "",
      unit_pack: "",
      quantity_multiplier: 1,
      originalIndex: null,
      total: 0,
      returned_quantity: 0,
    });

    setMedicineSearch("");
    setselected_medicine({});
  };

  // Update medicine quantity - UPDATED to preserve returned_quantity
  const updateQuantity = (index, newQuantity) => {
    if (newQuantity < 1) return;

    const updatedMedicines = [...selectedMedicines];
    const currentReturnedQty = updatedMedicines[index].returned_quantity || 0; // Preserve returned_quantity

    updatedMedicines[index].quantity = parseInt(newQuantity) || 1;
    const subtotal =
      updatedMedicines[index].quantity * updatedMedicines[index].mrp || 0;
    const base_price =
      updatedMedicines[index].mrp /
        (1 + updatedMedicines[index].gst_percentage / 100) || 0;
    const tax_amount_per_unit = updatedMedicines[index].mrp - base_price;
    const tax_amount = updatedMedicines[index].quantity * tax_amount_per_unit;

    updatedMedicines[index].cgst = tax_amount / 2 || 0;
    updatedMedicines[index].sgst = tax_amount / 2 || 0;
    updatedMedicines[index].total = subtotal || 0;
    updatedMedicines[index].returned_quantity = currentReturnedQty; // Preserve returned_quantity

    setSelectedMedicines(updatedMedicines);
  };

  // Remove medicine from table
  const removeMedicine = (index) => {
    const updatedMedicines = selectedMedicines.filter((_, i) => i !== index);
    setSelectedMedicines(updatedMedicines);
  };

  // Handle payment input changes
  const handlePaymentInputChange = (e) => {
    const { name, value } = e.target;
    setPaymentData((prev) => ({ ...prev, [name]: value }));
  };

  // Add payment to table
  const addPaymentToTable = () => {
    if (!paymentData.pay_type || !paymentData.paid_amount) {
      alert("Please fill in all payment fields.");
      return;
    }
    const paidAmount = parseFloat(paymentData.paid_amount) || 0;
    if (paidAmount <= 0) {
      alert("Paid amount must be greater than zero.");
      return;
    }
    const newPayment = {
      paid_date: paymentData.paid_date,
      pay_type: paymentData.pay_type,
      paid_amount: paidAmount,
    };
    setPaymentTableData((prev) => [...prev, newPayment]);
    setPaymentData({
      paid_date: new Date().toISOString().split("T")[0],
      pay_type: "",
      paid_amount: "",
    });
  };

  // Remove payment from table
  const removePaymentFromTable = (index) => {
    const updatedPayments = paymentTableData.filter((_, i) => i !== index);
    setPaymentTableData(updatedPayments);
  };

  // Handle form submission for update - UPDATED to ensure returned_quantity is sent to API
  const handleSubmit = async () => {
    if (
      !formData.invoice_number ||
      !formData.patient_id ||
      selectedMedicines.length === 0
    ) {
      alert(
        "Please fill in invoice, patient, and select at least one medicine."
      );
      return;
    }

    try {
      const saleData = {
        sale_date: formData.sale_date,
        invoice_number: formData.invoice_number,
        patient_id: formData.patient_id,
        gst_amount: formData.gst_amount || 0,
        apply_gst: formData.apply_gst,
        sub_total: formData.sub_total || 0,
        discount_percentage: formData.discount_percentage || 0,
        discount_value: formData.discount_value || 0,
        net_total: formData.net_total || 0,
        round_off: formData.round_off || 0,
        paid: formData.paid || 0,
        balance: formData.balance || 0,
        notes: formData.notes || "",
        payment_type: formData.payment_type || "",
        sales_list: selectedMedicines.map((item) => ({
          medicine_id: item.medicine_id || "",
          medicine_name: item.medicine_name || "",
          batch_no: item.batch_no || "",
          hsn_code: item.hsn_code || "",
          quantity: parseInt(item.quantity) || 0,
          returned_quantity: parseInt(item.returned_quantity) || 0, // Ensure this is sent to API
          expiry_date: item.expiry_date || "",
          mrp: parseFloat(item.mrp) || 0,
          gst_percentage: parseFloat(item.gst_percentage) || 0,
          cgst: parseFloat(item.cgst) || 0,
          sgst: parseFloat(item.sgst) || 0,
          total: parseFloat(item.total) || 0,
          unit: item.unit || "",
          unit_pack: item.unit_pack || "1*1",
        })),
      };

      // console.log(
      //   "Sending sale data with returned_quantity:",
      //   saleData.sales_list
      // );

      console.log("the saleData before update is :", saleData);

      const response = await axios.put(
        `${Apiurl}/sale_pharmacy/${id}`,
        saleData
      );

      if (response.status === 200) {
        if (paymentTableData.length > 0) {
          const paymentsData = {
            invoice_number: formData.invoice_number,
            payments: paymentTableData,
          };
          await axios.post(`${Apiurl}/sale_payment_pharmacy`, paymentsData);
        }
        alert("Sale updated successfully!");
        navigate("/pharmacy/sale-pharmacy");
      } else {
        alert("Sale update failed. Please try again.");
      }
    } catch (error) {
      console.error("Error updating sale:", error);
      alert(
        `Failed to update sale: ${
          error.response?.data?.message || error.message
        }`
      );
    }
  };

  // Handle cancel
  const handleCancel = () => {
    navigate("/pharmacy/sale-pharmacy");
  };

  // Clear form
  const handleClearOverAll = () => {
    const currentInvoiceNumber = formData.invoice_number;
    setSelectedMedicines([]);
    setFormData({
      sale_date: new Date().toISOString().split("T")[0],
      invoice_number: currentInvoiceNumber,
      patient_id: "",
      patient_name: "",
      mobile: "",
      discount_percentage: 0,
      discount_value: 0,
      apply_gst: true,
      gst_amount: 0,
      sub_total: 0,
      net_total: 0,
      round_off: 0,
      paid: 0,
      balance: 0,
      notes: "",
      payment_type: "",
    });
    setPatientSearch("");
    setPaymentTableData([]);
    setMedicineSearch("");
    setSelectedMedicine({
      stock_id: "",
      medicine_id: "",
      medicine_name: "",
      hsn_code: "",
      batch_no: "",
      balance_quantity: 0,
      quantity: 0,
      mrp: 0,
      gst_percentage: 0,
      cgst: 0,
      sgst: 0,
      expiry_date: "",
      unit: "",
      unit_pack: "",
      quantity_multiplier: 1,
      originalIndex: null,
      total: 0,
      returned_quantity: 0,
    });
    setselected_medicine({});
  };

  if (isLoading) return <div>Loading...</div>;

  return (
    <>
      <div className="p-3">
        <div className="row">
          <div className="col-lg-9 col-xl-9">
            <div className="card">
              <div className="card-body py-1 px-3">
                <div className="row g-2 align-items-center">
                  <div className="col-md-6 col-lg-6 col-xl-6">
                    <label htmlFor="patientId" className="mb-1 fw-bold">
                      Patient ID
                    </label>
                    <div className="position-relative">
                      <input
                        className="form-control"
                        type="text"
                        value={patientSearch}
                        onChange={(e) => setPatientSearch(e.target.value)}
                        onFocus={handlePatientFocus}
                        onBlur={handlePatientBlur}
                        placeholder="Search Patient (ID or Name)"
                        autoComplete="off"
                      />
                      <i className="bi bi-caret-down-fill position-absolute end-0 top-50 translate-middle-y me-3"></i>
                      {showPatientDropdown && (
                        <div
                          style={{
                            position: "absolute",
                            top: "100%",
                            zIndex: 1000,
                            width: "100%",
                            maxHeight: "200px",
                            overflowY: "auto",
                            backgroundColor: "white",
                            border: "1px solid #ddd",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                          }}
                        >
                          {isLoadingPatients ? (
                            <div
                              style={{ padding: "8px", textAlign: "center" }}
                            >
                              Loading...
                            </div>
                          ) : filteredPatients.length > 0 ? (
                            filteredPatients.map((patient, index) => (
                              <div
                                key={patient.patient_id || index}
                                style={{
                                  padding: "8px",
                                  cursor: "pointer",
                                  borderBottom: "1px solid #eee",
                                  backgroundColor: "#fff",
                                }}
                                onMouseDown={(e) => {
                                  e.preventDefault();
                                  selectPatient(patient);
                                }}
                              >
                                {patient.patient_id} - {patient.first_name}
                                <div
                                  style={{ fontSize: "0.8rem", color: "#666" }}
                                >
                                  {patient.mobile_no}
                                </div>
                              </div>
                            ))
                          ) : (
                            <div
                              style={{
                                padding: "8px",
                                color: "#666",
                                fontStyle: "italic",
                              }}
                            >
                              No Matching Patients Found
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-3 col-lg-3 col-xl-3">
                    <label className="mb-1 fw-bold">Patient Name</label>
                    <input
                      className="form-control"
                      type="text"
                      name="patient_name"
                      value={formData.patient_name}
                      onChange={handleInputChange}
                      placeholder="Enter Patient Name"
                    />
                  </div>
                  <div className="col-md-3 col-lg-3 col-xl-3">
                    <label className="mb-1 fw-bold">Patient Mobile</label>
                    <input
                      className="form-control"
                      type="text"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleInputChange}
                      placeholder="Enter Patient Mobile"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-xl-3">
            <div className="card">
              <div className="card-body py-1 px-3">
                <div className="row g-2">
                  <div className="col-md-6 col-lg-6 col-xl-6">
                    <label className="mb-1 fw-bold">Date</label>
                    <input
                      type="date"
                      className="form-control"
                      name="sale_date"
                      value={formData.sale_date}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="col-md-6 col-lg-6 col-xl-6">
                    <label className="mb-1 fw-bold">Invoice Number</label>
                    <input
                      className="form-control"
                      type="text"
                      name="invoice_number"
                      value={formData.invoice_number}
                      readOnly
                      placeholder="Invoice Number"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-3">
        <div className="row">
          <div className="col-md-8 col-lg-9 col-xl-9">
            <div className="border rounded p-3 bg-white">
              <div className="row">
                <div className="col-md-4 col-lg-4 col-xl-4 mb-2">
                  <label className="form-label fw-bold">Medicine Name</label>
                  <div className="position-relative">
                    <input
                      type="text"
                      className="form-control"
                      value={medicineSearch}
                      onChange={(e) => setMedicineSearch(e.target.value)}
                      onFocus={handleMedicineFocus}
                      onBlur={handleMedicineBlur}
                      placeholder="Search Medicine, Batch, or HSN"
                    />
                    <i className="bi bi-caret-down-fill position-absolute end-0 top-50 translate-middle-y me-3"></i>
                    {showMedicineDropdown && (
                      <div
                        style={{
                          position: "absolute",
                          top: "100%",
                          zIndex: 1000,
                          width: "100%",
                          maxHeight: "200px",
                          overflowY: "auto",
                          backgroundColor: "white",
                          border: "1px solid #ddd",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                        }}
                      >
                        {filteredMedicines.length > 0 ? (
                          filteredMedicines.map((medicine, index) => (
                            <div
                              key={medicine._id || index}
                              style={{
                                padding: "8px",
                                cursor: "pointer",
                                borderBottom: "1px solid #eee",
                                backgroundColor: "#fff",
                              }}
                              onMouseDown={(e) => {
                                e.preventDefault();
                                selectMedicine(medicine);
                              }}
                            >
                              {medicine.medicine_details?.medicine_name ||
                                medicine.medicine_details?.[0]?.medicine_name ||
                                "Unknown"}
                              <div
                                style={{ fontSize: "0.8rem", color: "#666" }}
                              >
                                Batch: {medicine.batch_no || "N/A"} | HSN:{" "}
                                {medicine.medicine_details?.hsn_code ||
                                  medicine.medicine_details?.[0]?.hsn_code ||
                                  "N/A"}{" "}
                                | Avl: {medicine.balance_quantity || 0} | Rs.{" "}
                                {(parseFloat(medicine.mrp) || 0).toFixed(2)} |
                                GST: {medicine.gst_percentage || "0"}%
                              </div>
                            </div>
                          ))
                        ) : (
                          <div
                            style={{
                              padding: "8px",
                              color: "#666",
                              fontStyle: "italic",
                            }}
                          >
                            No Matching Medicines Found
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-2 col-lg-2 col-xl-2 mb-2">
                  <label className="form-label fw-bold">Qty</label>
                  <input
                    type="number"
                    className="form-control"
                    name="quantity"
                    value={selectedMedicine.quantity}
                    onChange={handleMedicineInputChange}
                    placeholder="Quantity"
                  />
                </div>
                <div className="col-md-2 col-lg-2 col-xl-2 mb-2">
                  <label className="form-label fw-bold">Unit</label>
                  <select
                    className="form-control"
                    name="unit"
                    value={selectedMedicine.unit}
                    onChange={handleMedicineInputChange}
                  >
                    <option value="">Select Unit</option>
                    <option value="Tablet">Tablet</option>
                    <option value="Pack">Pack</option>
                    <option value="Per Piece">Per Piece</option>
                    <option value="Bottle">Bottle</option>
                    <option value="Strip">Strip</option>
                    {selectedMedicine.medicine_name === "Consumables" && (
                      <option value="Other">Other</option>
                    )}
                  </select>
                </div>
                <div className="col-md-2 col-lg-2 col-xl-2 mb-2">
                  <label className="form-label fw-bold">Price</label>
                  <input
                    type="text"
                    className="form-control"
                    name="mrp"
                    value={
                      selectedMedicine.medicine_name === "Consumables"
                        ? selectedMedicine.mrp || ""
                        : selectedMedicine.mrp
                        ? parseFloat(selectedMedicine.mrp).toFixed(2)
                        : ""
                    }
                    readOnly={selectedMedicine.medicine_name !== "Consumables"}
                    onChange={handleMedicineInputChange}
                  />
                </div>
                <div className="col-md-1 col-lg-1 col-xl-1 mt-4">
                  <button
                    type="button"
                    className="btn btn-sm btn-success w-100"
                    onClick={addMedicineToTable}
                  >
                    {selectedMedicine.originalIndex !== null ? "Update" : "+"}
                  </button>
                </div>
              </div>
              <div className="table-responsive table-scroll-350">
                <table className="table table-bordered mb-0">
                  <thead className="text-center">
                    <tr>
                      {[
                        "S.no",
                        "Medicine Name",
                        "Qty",
                        "Return",
                        "Unit",
                        "Price",
                        "GST %",
                        "Amount",
                        "Action",
                      ].map((h, idx) => (
                        <th
                          key={idx}
                          style={{
                            backgroundColor: "#01AEBE",
                            color: "white",
                          }}
                        >
                          {h}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="text-center">
                    {selectedMedicines.length > 0 ? (
                      selectedMedicines.map((item, index) => (
                        <tr key={item.stock_id || index}>
                          <td>{index + 1}</td>
                          <td>{item.medicine_name || "N/A"}</td>
                          <td>
                            <div className="d-flex justify-content-center gap-1">
                              <input
                                type="number"
                                className="form-control form-control-sm text-center"
                                style={{ width: "60px" }}
                                value={item.quantity || 0}
                                onChange={(e) =>
                                  updateQuantity(
                                    index,
                                    parseInt(e.target.value) || 1
                                  )
                                }
                              />
                            </div>
                          </td>
                          <td>{item.returned_quantity || "-"}</td>
                          <td>{item.unit || "N/A"}</td>
                          <td>{(parseFloat(item.mrp) || 0).toFixed(2)}</td>
                          <td>{parseFloat(item.gst_percentage) || 0}%</td>
                          <td>{(parseFloat(item.total) || 0).toFixed(2)}</td>
                          <td className="d-flex justify-content-center gap-1">
                            <button
                              className="btn btn-sm p-1 border-0"
                              style={{ backgroundColor: "transparent" }}
                              onClick={() => editMedicine(item, index)}
                            >
                              <Edit size={16} className="text-primary" />
                            </button>
                            <button
                              className="btn btn-sm p-1 border-0"
                              style={{ backgroundColor: "transparent" }}
                              onClick={() => removeMedicine(index)}
                            >
                              <Trash2 size={16} className="text-danger" />
                            </button>
                            <button
                              className="btn btn-sm p-1 border-0"
                              style={{ backgroundColor: "transparent" }}
                              onClick={() => handleReturnClick(item)}
                            >
                              <ArrowLeftRight
                                size={18}
                                className="text-primary"
                              />
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="9" className="text-center">
                          No medicines selected
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-lg-3 col-xl-3">
            <div className="row card card-body">
              <div className="row">
                <div className="col-5 col-md-5 col-lg-5 col-xl-5">
                  <label className="text-dark fw-bold">Sub Total</label>
                </div>
                <div className="col-7 col-md-7 col-lg-7 col-xl-7">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    value={(parseFloat(formData.sub_total) || 0).toFixed(2)}
                    readOnly
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-5 col-md-5 col-lg-5 col-xl-5">
                  <label className="fw-bold">Discount</label>
                </div>
                <div className="col-7 col-md-7 col-lg-7 col-xl-7">
                  <input
                    type="number"
                    className="form-control form-control-sm"
                    name="discount_percentage"
                    value={formData.discount_percentage || 0}
                    onChange={handleInputChange}
                    placeholder="Discount %"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-5 col-md-5 col-lg-5 col-xl-5">
                  <label className="fw-bold">Tax</label>
                </div>
                <div className="col-7 col-md-7 col-lg-7 col-xl-7">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    value={(parseFloat(formData.gst_amount) || 0).toFixed(2)}
                    readOnly
                    placeholder="Tax Amount"
                  />
                </div>
              </div>
              <div style={{ backgroundColor: "#01AEBE" }}>
                <div className="row pt-3 pb-0 p-2">
                  <label className="col-5 fs-5 col-form-label pt-3 text-white fw-bold">
                    Net Total
                  </label>
                  <div className="col-7">
                    <input
                      type="text"
                      className="form-control text-end fs-4 fw-bold text-primary"
                      value={(parseFloat(formData.net_total) || 0).toFixed(2)}
                      readOnly
                    />
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-5 col-md-5 col-lg-5 col-xl-5">
                  <label className="fw-bold">Payment Type</label>
                </div>
                <div className="col-7 col-md-7 col-lg-7 col-xl-7">
                  <select
                    className="form-control"
                    name="payment_type"
                    value={formData.payment_type || ""}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Payment Type</option>
                    <option value="Cash">Cash</option>
                    <option value="Card">Card</option>
                  </select>
                </div>
              </div>
              <div className="row mb-2">
                <button
                  type="button"
                  className="btn btn-lg fw-bold btn-success fs-5 w-100"
                  onClick={() => setShowAddModal(true)}
                >
                  Pay
                </button>
              </div>
              <div className="row mt-2">
                <div className="col-5 col-md-5 col-lg-5 col-xl-5">
                  <label className="fw-bold">Paid</label>
                </div>
                <div className="col-7 col-md-7 col-lg-7 col-xl-7">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    value={(parseFloat(formData.paid) || 0).toFixed(2)}
                    readOnly
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-5 col-md-5 col-lg-5 col-xl-5">
                  <label className="fw-bold">Balance</label>
                </div>
                <div className="col-7 col-md-7 col-lg-7 col-xl-7">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    value={(parseFloat(formData.balance) || 0).toFixed(2)}
                    readOnly
                  />
                </div>
              </div>
              <div className="row text-center mt-3">
                <div className="col-4">
                  <button
                    className="btn btn-sm btn-secondary w-100"
                    onClick={handleClearOverAll}
                  >
                    Clear
                  </button>
                </div>
                <div className="col-4">
                  <button
                    className="btn btn-sm btn-success w-100"
                    onClick={handleSubmit}
                  >
                    Update
                  </button>
                </div>
                <div className="col-4">
                  <button
                    className="btn btn-sm btn-danger w-100"
                    onClick={handleCancel}
                  >
                    Back
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Payment Modal */}
      <div
        className={`modal fade ${showAddModal ? "show d-block" : ""}`}
        tabIndex="-1"
        aria-labelledby="addPaymentModalLabel"
        aria-hidden={!showAddModal}
        style={{
          backgroundColor: "rgba(0,0,0,0.5)",
          transition: "opacity 0.3s ease-in-out",
        }}
      >
        <div className="modal-dialog modal-xl modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title fw-bold" id="addPaymentModalLabel">
                Add Payment Details
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowAddModal(false)}
              ></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-2 mb-2">
                  <label className="form-label fw-bold">Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="paid_date"
                    value={paymentData.paid_date || ""}
                    onChange={handlePaymentInputChange}
                  />
                </div>
                <div className="col-lg-2 mb-2">
                  <label className="form-label fw-bold">Total Amount</label>
                  <input
                    type="text"
                    className="form-control"
                    value={(parseFloat(formData.net_total) || 0).toFixed(2)}
                    readOnly
                  />
                </div>
                <div className="col-lg-2 mb-2">
                  <label className="form-label fw-bold">Payment Type</label>
                  <div className="position-relative">
                    <select
                      className="form-control"
                      name="pay_type"
                      value={paymentData.pay_type || ""}
                      onChange={handlePaymentInputChange}
                    >
                      <option value="">Payment Type</option>
                      <option value="Cash">Cash</option>
                      <option value="Card">Card</option>
                      <option value="Gpay">Gpay</option>
                      <option value="Phonepe">Phonepe</option>
                      <option value="Paytm">Paytm</option>
                      <option value="Amazon Pay">Amazon Pay</option>
                      <option value="UPI">UPI</option>
                    </select>
                    <i className="bi bi-caret-down-fill position-absolute end-0 top-50 translate-middle-y me-3"></i>
                  </div>
                </div>
                <div className="col-lg-2 mb-2">
                  <label className="form-label fw-bold">Paid Amount</label>
                  <input
                    type="number"
                    className="form-control"
                    name="paid_amount"
                    value={paymentData.paid_amount || ""}
                    onChange={handlePaymentInputChange}
                    placeholder="Enter Paid Amount"
                  />
                </div>
                <div className="col-lg-2 mb-2">
                  <label className="form-label fw-bold">Balance Amount</label>
                  <input
                    type="text"
                    className="form-control"
                    value={(parseFloat(formData.balance) || 0).toFixed(2)}
                    readOnly
                  />
                </div>
                <div className="col-lg-2 mb-2 d-flex align-items-end">
                  <button
                    type="button"
                    className="btn btn-success w-100"
                    onClick={addPaymentToTable}
                  >
                    ADD
                  </button>
                </div>
              </div>
              <div className="table-responsive mt-3">
                <table className="table table-bordered">
                  <thead className="text-center">
                    <tr>
                      {[
                        "S.no",
                        "Paid Date",
                        "Pay Type",
                        "Amount",
                        "Action",
                      ].map((h, idx) => (
                        <th
                          key={idx}
                          style={{
                            backgroundColor: "#01AEBE",
                            color: "white",
                          }}
                        >
                          {h}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="text-center">
                    {paymentTableData.length > 0 ? (
                      paymentTableData.map((item, index) => (
                        <tr key={item.id || index}>
                          <td>{index + 1}</td>
                          <td>{item.paid_date || "N/A"}</td>
                          <td>{item.pay_type || "N/A"}</td>
                          <td>
                            {(parseFloat(item.paid_amount) || 0).toFixed(2)}
                          </td>
                          <td className="d-flex justify-content-center gap-1">
                            <button
                              className="btn btn-sm p-1 border-0"
                              style={{ backgroundColor: "transparent" }}
                              onClick={() => removePaymentFromTable(index)}
                            >
                              <Trash2 size={16} className="text-danger" />
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center">
                          No payments added
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateSalePharmacy;
